import { render, staticRenderFns } from "./adidData.vue?vue&type=template&id=674aec8b&scoped=true"
import script from "./adidData.vue?vue&type=script&lang=js"
export * from "./adidData.vue?vue&type=script&lang=js"
import style0 from "./adidData.vue?vue&type=style&index=0&id=674aec8b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674aec8b",
  null
  
)

export default component.exports